import { createReducer, on } from '@ngrx/store';

import { shiftAction } from './shift.actions';

export const shiftKey = 'shift';

export interface ShiftState {
  shiftList: any;
  shiftDetail: any;
}

export const initialState: ShiftState = {
  shiftList: null,
  shiftDetail: null
};

export const shiftReducer = createReducer<ShiftState>(
  initialState,
  on(shiftAction.shiftListResponse, (state, response) => {
    return { ...state, shiftList: response.response };
  }),
  on(shiftAction.viewShiftResponse, (state, response) => {
    return { ...state, shiftDetail: response.response };
  })
);
